import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { BomDataHelper } from '../../services/helpers/bom-data-helper';
import { GTM } from 'src/app/services/gtm.service';
import { CONTEXT } from 'src/app/enum/context';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'ng-hbm-bdi-price-infos',
  templateUrl: './price-infos.component.html'
})
export class PriceInfosComponent implements OnInit {

  public handledBom: any;

  constructor(public modalService: ModalService, private gtm: GTM, private user: UserService) {
    this.handledBom = BomDataHelper.extractBlockGroupedProductsList(modalService.currentDatas.bom);
  }

  ngOnInit(): void {
    this.gtm.trackEvent('click', 'info-price-' + this.user.context.toLowerCase(), 'open', {'project_amount': this.handledBom.totalPrice.toFixed(2)});
  }

  close() {
    this.gtm.trackEvent('click', 'info-price-' + this.user.context.toLowerCase(), 'close', {'project_amount': this.handledBom.totalPrice.toFixed(2)});
    this.modalService.close();
  }
}
